import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import TituloComponent from '../../components/Titulo/TituloComponent';
import BotaoAndamentoPedido from '../../components/BotaoAndamentoPedido/BotaoAndamentoPedido';
// css
import '../../styles/global.css';
import './BarCozinhaPage.css';


const BarCozinha = () => {
  const navigate = useNavigate();
  
  // Pega os dados da sessão diretamente
  const userData = JSON.parse(sessionStorage.getItem('userData')); // Assume que os dados estão armazenados no sessionStorage
  const statusUsuario = userData?.statusUsuario;
  const nomePerfil = userData?.dadosPerfil?.nome;
  const nomeUsuario = userData?.user.name;

  const [isAuthorized, setIsAuthorized] = useState(true);


  useEffect(() => {
    // Verifica se o usuário tem o perfil correto e está logado
    if (!userData || userData.dadosPerfil?.nome !== 'BAR COZINHA' || userData.statusUsuario !== 'logado') {
      console.log(' !!!! Perfil não autorizado ou usuário não logado. Redirecionando...');
      setIsAuthorized(false); // Atualiza o estado de autorização
      navigate('/area-restrita'); // Redireciona para a página de login ou área restrita
    } else {
      console.log('--- PAGINA COZINHA ---');
      console.log('Dados completos do usuário:', userData);
      console.log('Status do usuário:', statusUsuario);
      console.log('Perfil do usuário:', nomePerfil);
    }
  }, [userData, statusUsuario, navigate]);

  // Função para fazer o logout
  const handleLogout = () => {
    // Remove os dados da sessão
    sessionStorage.removeItem('userData');
    // Redireciona para a página de login
    navigate('/area-restrita');
  };

  // Função para redirecionar para DadosDoEstabelecimentoPage
  const handleGoToPedidos = () => {
    navigate('/pedidos');
  };

  // se o usuário não estiver autorizado
  if (!isAuthorized) {
    return <div>Redirecionando...</div>;
  }

  return (
    <div autoFocus className="bar-gerente-container">
        <TituloComponent />
        <h1 className="sub-titulo">Área da Cozinha</h1>
        
        <div className="box-dados">
            {/* Exibe o nome do perfil do usuário */}
            <p className="texto-welcome">{userData.dadosEstabelecimento.nome}!</p>
            <p >Bem-vindo, {nomeUsuario}!</p>
            {/* Botão de Logout */}
            <button className="welcome-btn" onClick={handleLogout}>Logout</button>
        </div>
        
        {/* Container de quadros */}
        <div className="quadros-container">
            <div className="quadro" onClick={handleGoToPedidos}>
                <h3>Pedidos</h3>
                <p>Visualize os pedidos para a cozinha.</p>
            </div>
        </div>

    </div>
  );
};

export default BarCozinha;
